const REASON_KEYS: Record<string, string> = {
  bad_password: 'security.reasons.badPassword',
  bad_otp: 'security.reasons.badCode',
  bad_email_otp: 'security.reasons.badCode',
  bad_backup_code: 'security.reasons.badCode',
  environment_changed: 'security.reasons.environmentChanged',
  hijack_suspected: 'security.reasons.hijackSuspected',
  locked: 'security.reasons.locked',
  rate_limited: 'security.reasons.rateLimited',
  unknown_email: 'security.reasons.badPassword',
};

const ALERT_EVENTS = new Set([
  'auth.session.hijack_suspected',
  'auth.login.environment_changed',
  'auth.login.locked',
]);

export function loginReasonKey(reason: string | null | undefined): string {
  if (!reason) {
    return '';
  }
  return REASON_KEYS[reason] ?? reason;
}

/** Обычный выход пишется как auth.sessions.terminated с cause=logout (всегда одна сессия). */
export function loginHistoryTitle(
  item: { eventType: string; cause?: string | null; description?: string | null },
  t: (key: string, options?: { defaultValue?: string }) => string,
): string {
  if (item.eventType === 'auth.sessions.terminated' && item.cause === 'logout') {
    return t('security.sessionLogout');
  }
  // Подписи событий общие с журналом аудита (auditLog.events). Текст бэка — только запасной вариант.
  return t(`auditLog.events.${item.eventType}`, { defaultValue: item.description || item.eventType });
}

export function formatSessionLabel(browser?: string | null, os?: string | null): string {
  return [browser, os].map((part) => part?.trim()).filter((part): part is string => Boolean(part)).join(' · ');
}

export function isSupportLoginActor(actor: string | null | undefined): boolean {
  return actor === 'support';
}

export function qrImageSrc(qr: string | null | undefined): string | null {
  if (!qr) {
    return null;
  }
  if (qr.startsWith('data:') || qr.startsWith('http://') || qr.startsWith('https://')) {
    return qr;
  }
  return `data:image/png;base64,${qr}`;
}

export function isAlertLoginEvent(eventType: string | null | undefined): boolean {
  return Boolean(eventType && ALERT_EVENTS.has(eventType));
}

/** Метка из миграции автовывода, не пользовательская подпись. */
const SYSTEM_ADDRESS_LABELS = new Set(['approved-auto-rule-migration']);

export function userFacingAddressLabel(label?: string | null): string | null {
  const trimmed = label?.trim() ?? '';
  if (!trimmed || SYSTEM_ADDRESS_LABELS.has(trimmed)) {
    return null;
  }
  return trimmed;
}

export function shortAddress(address: string): string {
  if (address.length <= 16) {
    return address;
  }
  return `${address.slice(0, 8)}…${address.slice(-6)}`;
}

const COOLING_SECONDS_THRESHOLD = 86_400;

/** User-facing whole hours for whitelist cooling (`holdHours` may be fractional hours or seconds). */
export function formatWithdrawalAddressHoldHours(
  value: number | null | undefined,
  fallbackHours = 24,
): number {
  if (value == null || !Number.isFinite(value) || value <= 0) {
    return fallbackHours;
  }
  const hours = value >= COOLING_SECONDS_THRESHOLD ? value / 3600 : value;
  return Math.max(1, Math.round(hours));
}
